<div class="fa fa-stack">
    <div [class]="baseClasses"></div>
    <div [class]="classes"></div>
</div> 